import { PageId } from 'constants/pages'
import { TPageConfig } from 'models/common.model'
import { PageIdWoofzInvx } from './pages'

export const ID_TO_PAGE_CONFIG_MAP_WOOFZ_INVX: Record<
  PageIdWoofzInvx,
  TPageConfig
> = {
  [PageId.SUBSCRIPTIONS_INVOXIA_INVX]: {
    id: PageId.SUBSCRIPTIONS_INVOXIA_INVX,
  },
  [PageId.INVOXIA_CONGRATULATIONS_INVX]: {
    id: PageId.INVOXIA_CONGRATULATIONS_INVX,
  },
  [PageId.INVOXIA_REVIEW_INVX]: {
    id: PageId.INVOXIA_REVIEW_INVX,
  },
  [PageId.INVOXIA_DETAILS_INVX]: {
    id: PageId.INVOXIA_DETAILS_INVX,
  },
}
